import root from "theme/theme-light/components/button/root";
import contained from "./contained";
import outlined from "./outlined";
import buttonText from "./text";
import variantBlur from "./variantBlur";
import variantGhost from "./variantGhost";
import { sizeLarge, sizeMedium, sizeSmall } from "./sizeButton";

const button = {
  defaultProps: {
    variant: "contained",
    color: "primary",
    size: "medium",
    // Mặc định các giá trị ban đầu cho Button
  },
  variants: [...variantBlur, ...variantGhost],
  styleOverrides: {
    root: { ...root },
    sizeSmall: { ...sizeSmall },
    sizeMedium: { ...sizeMedium },
    sizeLarge: { ...sizeLarge },

    containedPrimary: { ...contained.containedPrimary },
    containedSuccess: { ...contained.containedSuccess },
    containedError: { ...contained.containedError },
    containedWarning: { ...contained.containedWarning },

    outlinedPrimary: { ...outlined.outlinedPrimary },
    outlinedSuccess: { ...outlined.outlinedSuccess },
    outlinedError: { ...outlined.outlinedError },
    outlinedWarning: { ...outlined.outlinedWarning },

    textPrimary: { ...buttonText.textPrimary },
    textSuccess: { ...buttonText.textSuccess },
    textError: { ...buttonText.textError },
    textWarning: { ...buttonText.textWarning },
  },
};

export default button;
